<template>
  <v-container grid-list-xl>

    <!-- add user form  !-->

    <v-form v-model="validCustomer" v-if="canAddUser">
      <v-layout row wrap>
        <v-flex lg6>
          <label class="blackLabel">* First Name</label>
          <v-text-field label="First Name" class="dropdown" v-model="firstName" :rules="firstNameRule" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg6 class="pt-5">
          <v-switch label="Create a New Customer"  v-model="canAddUser"></v-switch>
        </v-flex>
        <v-flex lg4>
          <label class="blackLabel">* Surname</label>
          <v-text-field label="Surname" class="dropdown" v-model="surname" :rules="surnameRule" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg4>
          <label class="blackLabel">* Contact No</label>
          <v-text-field label="Contact No" class="dropdown" :rules="contactNoRule" v-model="contactNo" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg3>
          <label class="blackLabel">* Username (Email Address)</label>
          <v-text-field label="Email Address" class="dropdown" :rules="usernameRule" browser-autocomplete="off" v-model="uName" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg4 v-show="false">
          <label class="blackLabel">* Password</label>
          <v-text-field label="Password" type="password"  v-model="uPass" browser-autocomplete="off" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg3 v-show="false">
          <label class="blackLabel">* Confirm Password</label>
          <v-text-field label="Confirm Password" type="password"  autocomplete="off" v-model="confirmPassword" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg4>
          <label class="blackLabel">Alternative Contact No</label>
          <v-text-field label="Alternative Contact No" class="dropdown" v-model="alternativeContactNo" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg4>
          <label class="blackLabel">Rep Code</label>
          <v-text-field label="User Rep Code" class="dropdown" v-model="userReference" solo single-line></v-text-field>
        </v-flex>
        <v-flex lg4>
          <label class="blackLabel">Active for MyOrder</label>
          <v-switch v-model="activeMyorder"></v-switch>
        </v-flex>
    </v-layout>
    </v-form>

    <!-- project from  !-->

    <v-form v-model="validProject" v-else-if="canAddProject">
      <v-layout row wrap>
        <v-flex lg6 >
          <v-switch label="Create New Project"  v-model="canAddProject"></v-switch>
        </v-flex>
        <v-flex lg6 >
        </v-flex>

        <v-flex lg6 v-if="objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1">
          <v-switch label="Include for Tendering" v-model="projectTendering"></v-switch>
        </v-flex>
        <v-flex lg6 v-if="objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1">
          <label class="blackLabel">Tender Closing Date</label>
          <date-picker v-model="projectTenderClosingDate" lang="en"></date-picker>
        </v-flex>

        <v-flex lg6>
          <label class="blackLabel">* Project Name</label>
          <v-text-field label="Project Name" :rules="projectNameRules" v-model="projectName" solo></v-text-field>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">Project Code</label>
          <v-text-field label="Project Code" v-model="projectCode" solo></v-text-field>
        </v-flex>

        <v-flex lg6>
          <label class="blackLabel">Project Reference</label>
          <v-text-field label="Project Reference" v-model="projectReference" solo></v-text-field>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">* Project Status</label>
          <v-select :items="leadStatusList" v-model="projectStatus" :rules="projectStatusRules" autocomplete placeholder="Status" class="dropdown" item-value="id" item-text="name" solo ></v-select>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">* Project Type</label>
          <v-select :items="projectTypeList" :rules="projectTypeRules" label="Project Type" v-model="projectType" item-value="id" class="dropdown" single-line solo></v-select>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">Project Professionals</label>
          <v-select :items="projectSpecifiers" label="No Specifier Assigned" @input="fncChangeSpecifierType" v-model="projectSpecifier" item-text="name" class="dropdown" single-line solo>
            <template v-slot:item="data" >
              <small v-html="data.item.name"></small>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- maim form  !-->

    <v-form v-model="valid" v-else>
      <v-layout row wrap>

        <v-flex lg6>
          <label class="blackLabel">* Existing Customer</label>
          <v-select :items="newLeadUsers" v-model="user" :rules="customerRule" autocomplete placeholder="User" class="dropdown" item-value="userid" item-text="name" solo ></v-select>
        </v-flex>
        <v-flex lg6 class="pt-5">
          <v-switch label="Create a New Customer"  v-model="canAddUser"></v-switch>
        </v-flex>

        <v-flex lg6>
          <label class="blackLabel">Company</label>
          <v-text-field label="Lead company" v-model="company" required   solo></v-text-field>
        </v-flex>
        <v-flex lg6>
        </v-flex>

        <v-flex lg6>
          <label class="blackLabel">Projects</label>
          <v-select :items="projectList" v-model="project"  autocomplete placeholder="project" class="dropdown" item-value="id" item-text="name" solo ></v-select>
        </v-flex>
        <v-flex lg6 class="pt-5">
          <v-switch label="Create New Project"  v-model="canAddProject"></v-switch>
        </v-flex>

        <v-flex lg6>
          <label class="blackLabel">* Lead Department</label>
          <v-select @input="fncCheckAllDepartments" solo single-line :items="globalModalParams.departments" v-model="department" :rules="departmentRule" autocomplete multiple  placeholder="Lead Department" class="dropdown" item-value="id" item-text="name" solo ></v-select>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">* Status</label>
          <v-select :items="statusList" v-model="lead_status"  :rules="statusRule" autocomplete placeholder="Status" class="dropdown" item-value="id" return-object item-text="description" solo ></v-select>
        </v-flex>

        <v-flex lg6 >
          <label class="blackLabel">* Store</label>
          <v-select :items="storeList" v-model="branch" :rules="branchRule" return-object  placeholder="Store" class="dropdown" item-value="id" item-text="name" solo ></v-select>
        </v-flex>
        <v-flex lg6 >
        </v-flex>

        <v-flex lg12>
          <label class="blackLabel">* Lead Description</label>
          <v-text-field label="Lead Description" v-model="lead_description" :rules="departmentRule" required  multi-line solo></v-text-field>
        </v-flex>

      </v-layout>
    </v-form>
    <div class="pl-4 pr-2 pb-4 buttonHolder">
      <div style="float: right">
        <v-btn class="text-xs-right cancelButton" @click.prevent="fncHideModal">Close</v-btn>
        <template v-if="!canAddUser && !canAddProject">
          <v-btn color="success" class="text-xs-right" :disabled="disabled" @click.prevent="fncCreateNewLeadQuote()" >Save</v-btn>
        </template>
        <template v-if="canAddProject && !canAddUser">
          <v-btn color="success" class="text-xs-right" :disabled="disabled" @click.prevent="fncCreateProject()" >Save</v-btn>
        </template>
        <template v-if="canAddUser && !canAddProject">
          <v-btn color="success" class="text-xs-right" :disabled="disabled" @click.prevent="fncCreateUser()" >Save</v-btn>
        </template>
      </div>
    </div>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    DatePicker
  },
  name: "modal-create-new-lead",
  data () {
    return {
      branch: '',
      company: '',
      validProject: false,
      project: '',
      canAddProject: false,
      validCustomer: false,
      valid:false,
      canAddUser: false,
      firstName:'',
      surname: '',
      contactNo: '',
      uName: '',
      uPass: '',
      confirmPassword:'',
      alternativeContactNo: '',
      confirmPasswordRule: [
        v => !!v || 'Please confirm your password',
      ],
      passwordRule: [
        v => !!v || 'Password is required',
      ],
      firstNameRule: [
        v => !!v || 'First Name is required',
      ],
      contactNoRule: [
        v => !!v || 'Contact No is required',
      ],
      usernameRule: [
        v => !!v || 'Username is required',
      ],
      surnameRule: [
        v => !!v || 'Surname is required',
      ],
      userReference: '',
      activeMyorder: true,

      /* lead creation */
      user: '',
      lead_description: '',
      lead_status: '',
      department: '',
      contributionMinimum: '0.00',
      vatNo: '',
      addressSelected: false,
      userVendor: '',
      userBranch: [],
      userDepartment: 0,
      branchListSorted: [],
      userResponsibleRep: false,
      branchesDepartments: [],
      userCommercialKam: false,
      userCommercialOriginator: false,
      regionContact: false,
      userCompany: '',
      maxDiscount: '0.00',
      defaultDiscount: '0.00',
      maxIncidentalValue: '0.00',
      contributionDefault: '0.00',
      linkUser: true,
      regions_added: [],
      customerRule: [
        v => !!v || 'Contact No is required',
      ],
      departmentRule: [
        v => !!v || 'Contact No is required',
      ],
      descriptionRule: [
        v => !!v || 'Contact No is required',
      ],
      statusRule: [
        v => !!v || 'Contact No is required',
      ],
      branchRule: [
        v => !!v || 'Contact No is required',
      ],

      /* project */
      projectTenderClosingDate: '',
      projectTendering: '',
      projectSpecifier: '',
      projectTypeList: [
        { id: 1, text: 'Government' },
        { id: 2, text: 'Private' },
        { id: 3, text: 'Unknown' }
      ],
      projectName: '',
      projectCode: '',
      projectReference: '',
      projectStatus: '',
      projectType: 2,
      projectNotes: '',
      siteDetails: '',
      contactDetails: '',
      projectAddresses: [],

      projectNameRules: [
        v => !!v || 'Project name is required',
      ],
      projectStatusRules: [
        v => !!v || 'Project status is required',
      ],
      projectTypeRules: [
        v => !!v || 'Project type is required',
      ],
      leadStatusList:[],
      storeList: [],
      statusList: []
    }
  },
  methods: {
    fncCheckAllDepartments() {
      if(  this.department.includes('all') && this.globalModalParams.departments.length !== this.department.length ) {
        this.department = [];
        this.department.push('all');
        for( var d in this.globalModalParams.departments ) {
          this.department.push( this.globalModalParams.departments[d].id );
        }
      }
      else
      {
        var newFilters = [];
        for( var d in this.department ) {
          if(this.department[d] != 'all') {
            newFilters.push(this.department[d]);
          }
        }
        if( newFilters.length == ( this.globalModalParams.departments.length - 1 ) )
        {
          this.department = [];
        }
        else
        {
          this.department = newFilters;
        }
      }
    },
    fncChangeSpecifierType() {
      this.projectSpecifierType = this.projectSpecifier.type;
    },
    fncCreateProject() {
      this.$store.dispatch({
        type: 'fncCreateProject',
        name: this.projectName,
        code: this.projectCode,
        projectType: this.projectType,
        specifier: this.projectSpecifier.id,
        specifierType: this.projectSpecifierType,
        inclTender: this.projectTendering,
        status: this.projectStatus,
        addresses: this.projectAddresses,
        vehicles: this.projectVehicles,
        notes: this.projectNotes,
        siteDetails: this.siteDetails,
        contactDetails: this.contactDetails,
        reference: this.projectReference,
        tenderClosingDate: this.projectTenderClosingDate,
        projectImages: this.projectImages,
        is_new_lead_project: true
      })
    },
    fncHideModal() {
      this.$store.commit('hideModal');
    },
    fncCreateNewLeadQuote(){
      this.$store.dispatch({
        type: 'fncCreateNewLeadQuote',
        user: this.user,
        lead_description: this.lead_description,
        lead_status: this.lead_status,
        department: this.department,
        project : this.project,
        company: this.company,
        branch: this.branch,
      });
    },
    fncCheckRegionSetup(regionId, regionStatus, regionParent) {
      this.addressSelected = true;
      this.$store.commit({
        type: 'fncCheckRegionSetup',
        regionId: regionId,
        regionStatus: regionStatus,
        parent: regionParent
      })
      if ( regionStatus == false ) {
        this.$store.commit('fncHideRegionParent', regionParent)
      }
    },
    fncSetModalTitle(name) {
      this.$store.commit('setGlobalModalTitle', name);
    },
      fncCreateUser() {

      var bdActive = [];
      for( var bd in this.branchesDepartments ) {
        if( this.branchesDepartments[bd].active == true || this.branchesDepartments[bd].active == 1 ) {
          bdActive.push(this.branchesDepartments[bd]);
        }
      }

      this.runAdd = true;
      this.$store.dispatch({
        type: 'fncCreateUser',
        activeMyorder: this.activeMyorder,
        linkUser: this.linkUser,
        sendConfirmation: false,
        userType: 4,
        firstName: this.firstName,
        surname: this.surname,
        contactNo: this.contactNo,
        alternativeContactNo: this.alternativeContactNo,
        username: this.uName,
        password: this.uPass,
        userCompany: this.userCompany,
        userRole: this.globalModalParams.role,
        maxDiscount: this.maxDiscount,
        defaultDiscount: this.defaultDiscount,
        maxIncidentalValue: this.maxIncidentalValue,
        contributionDefault: this.contributionDefault,
        contributionMinimum: this.contributionMinimum,
        vatNo: this.vatNo,
        regionContact: this.regionContact,
        userVendor: this.userVendor,
        userBranch: this.userBranch,
        userDepartment: this.userDepartment,
        userReference: this.userReference,
        userResponsibleRep: this.userResponsibleRep,
        commercialKam: this.userCommercialKam,
        commercialOriginator: this.userCommercialOriginator,
        branchesDepartments: bdActive,
        is_lead_create: true
        // branchesDepartments: this.branchesDepartments
      })
    }
  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'globalModalParams',
      'regionSelectors',
      'userAddRoles',
      'userAddCompanies',
      'userVendors',
      'branchList',
      'departmentList',
      'userRegions',
      'leadUserSelected',
      'newLeadUsers',
      'projectList',

      'projectStatusList',
      'projectSpecifiers',
      'selectedNewLeadProject',
      'tabs'
    ]),
    disabled(){
      if (this.canAddUser){
        if (this.validCustomer){
          return false
        }
        return  true
      }
      else if (this.canAddProject){
        return  (this.validProject) ? false : true
      }
      else{
        if (this.valid){
          return false
        }
        return true
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateProjectList');
    this.$store.dispatch('fncPopulateBranches');
  },
  mounted() {
    if( this.globalModalParams.departments.length > 0 ) {
      this.globalModalParams.departments.unshift({id: 'all', name: 'All'});
    }

    if (this.branchList.length > 0){
      let ar = this.branchList
      for (const [key, value] of Object.entries(ar)) {
        this.storeList.push({name: this.branchList[key].name, id: this.branchList[key].id, code: this.branchList[key].code})
      }
    }

  },
  created() {
    this.$store.dispatch('fncPopulateRegionList');
    this.$store.dispatch('fncPopulateProjectStatusList');
    this.$store.dispatch('fncPopulateProjectSpecifiers');
    this.linkType = [{ id: 1, text: this.objAuthorize.manu_user_alias }];

    if (this.objAuthorize.privileges.indexOf('HIDE_CUSTOMER_USERS') == -1 ) {
      this.linkType.push({ id: 2, text: this.objAuthorize.customer_user_alias });
    }

    if (this.objAuthorize.privileges.indexOf('HIDE_SPECIFIER_USERS') == -1) {
      this.linkType.push({ id: 3, text: this.objAuthorize.specifier_user_alias });
    }

    if (this.objAuthorize.privileges.indexOf('HIDE_SPECIFIER_USERS') == -1) {
      this.linkType.push({ id: 4, text: this.objAuthorize.public_user_alias });
    }

    if (this.objAuthorize.privileges.indexOf('HIDE_VENDOR_USERS') == -1) {
      this.linkType.push({ id: 6, text: 'Vendor Users' });
    }

    let chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let array = new Uint32Array(chars.length);
    window.crypto.getRandomValues(array);

    for (let i = 0; i < 8; i++) {
      this.uPass += chars[array[i] % chars.length];
    }

    this.confirmPassword = this.uPass;
    this.uName = '';

    if (this.tabs.is_new_lead !== undefined && Object.keys(this.tabs.is_new_lead).length > 0)
    {
      for (const [key, value] of Object.entries(this.tabs.is_new_lead)) {
        this.statusList.push({description: this.tabs.is_new_lead[key].description, id: this.tabs.is_new_lead[key].id})
      }
    }

  },
  watch: {
    canAddProject(){
      if (this.canAddProject){
        this.fncSetModalTitle('Create New Lead >> Create Project')
      }
      else
        this.fncSetModalTitle('Create New Lead')
    },
    canAddUser(){
      if (this.canAddUser){
        this.fncSetModalTitle('Create New Lead >> Create Customer')
      }
      else
        this.fncSetModalTitle('Create New Lead')
    },
    selectedNewLeadProject(){
      if (this.selectedNewLeadProject !== ""){
        this.project = parseInt(this.selectedNewLeadProject)
        this.canAddProject = false
      }
    },
    userRegions() {
      if( this.objAuthorize.manufacturer == '385889803' ) {
        var topLevelRegion = this.userRegions[0].id;
        this.fncCheckRegionSetup(topLevelRegion, true, '0');
      }
    },
    leadUserSelected()
    {
      if (this.leadUserSelected !== ''){
        this.canAddUser = false
        this.user = parseInt(this.leadUserSelected)
      }
    },
    projectStatusList(){
      let ar = this.projectStatusList
      let count = 0
      for (const [key, value] of Object.entries(ar)) {
        for (const [index, data] of Object.entries(ar[key])) {
         if (typeof ar[key][index] === 'object'){
           this.leadStatusList.push({ name: ar[key][index].description, id: ar[key][index].id })
          }
        }
      }
    },

  }
}
</script>

<style scoped>

</style>
